import React from 'react';

interface Prop {
  width?: string;
  height?: string;
  color?: string;
  fontSize?: string;
}

const behance = ({ width, height, color, fontSize }: Prop) => {
  return (
    <svg
      style={{ fontSize: fontSize || '2.1875rem' }}
      xmlns="http://www.w3.org/2000/svg"
      width={width || '1em'}
      height={height || '1em'}
      viewBox="0 0 107.576 69.14"
    >
      <path
        id="Icon_awesome-behance"
        data-name="Icon awesome-behance"
        d="M42.252,36.03c6.037-2.886,11.523-8.568,11.523-15.364C53.775,7.263,42.252,5.3,30.729,5.3H0v69.14H30.729c12.226,0,26.888-9.378,26.888-23.047C57.617,42.947,50.529,38.365,42.252,36.03ZM15.364,16.825H26.888c5.334,0,11.523,1.493,11.523,7.682,0,5.714-2.4,7.682-7.682,7.682H15.364ZM30.729,62.918H15.364V43.713H30.729c6.511,0,11.523.791,11.523,7.682A11.464,11.464,0,0,1,30.729,62.918Zm69.14-46.093H72.981V9.143H99.869Zm7.682,30.729c0-14.409-7.765-26.888-23.047-26.888-14.845,0-23.047,12.27-23.047,26.888,0,15.168,7.67,26.888,23.047,26.888,11.637,0,19.421-4.221,23.047-15.364H96.028c-1.272,4.157-7.461,3.841-11.523,3.841-7.84,0-11.523-3.721-11.523-11.523h34.57C107.608,50.6,107.551,48.408,107.551,47.554Zm-34.57-3.841c.437-6.4,5.107-11.523,11.523-11.523,6.72,0,10.954,5.069,11.523,11.523Z"
        transform="translate(0 -5.302)"
        fill={`${color || '#212121'}`}
      />
    </svg>
  );
};

export default behance;
